import $ from "jquery";
import Swal from "sweetalert2";
import { baseUrl, apiUrl } from "@/utils/api";
import i18n from "@/plugins/i18n";

// Configure SweetAlert2 Toast for minimal, lightweight notifications
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  showCloseButton: false,
  timer: 2500,
  timerProgressBar: false,
  backdrop: false,
  allowOutsideClick: true,
  showClass: {
    popup: "cart-toast-fade-in",
  },
  hideClass: {
    popup: "cart-toast-fade-out",
  },
  customClass: {
    popup: "cart-toast-minimal",
    title: "cart-toast-title-minimal",
  },
});

// Helper function to get fresh token from localStorage
function getToken() {
  return localStorage.getItem("access_token");
}

export function addToCart(itemId, event, itemType) {
  const addToCartBtn = $(event.target).closest("button"); // Get the button element
  const originalContent = addToCartBtn.html(); // Store original button content

  addToCartBtn
    .addClass("disabled")
    .html(
      `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${i18n.global.t(
        "cart.adding"
      )}`
    );

  let addUrl;
  const requestData = {};
  if (itemType === "bundle") {
    requestData.bundle_id = itemId;
    addUrl = `${apiUrl}/addtocart/bundle?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`;
  }
  if (itemType === "course") {
    requestData.course_id = itemId;
    addUrl = `${apiUrl}/addtocart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`;
  }

  /*$.ajax({
    url: addUrl,
    method: "POST",
    data: requestData,
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
    },
    success: function (response) {
      console.log("Item added to cart successfully!");
      alertify.success("تم الإضافة الى السلة بنجاح");
      showCart();
      //$("#cartModal").modal("show");
    },
    error: function (xhr, status, error) {
      console.error("Error adding item to cart:", error);
      console.log(xhr.responseText);
      const responseText = xhr.responseText;
      if (responseText === '  "Course is already in cart !"') {
        alertify.error("هذه الدورة موجودة في السلة مسبقاً");
      } else if (responseText !== '  "Course is already in cart !"') {
        alertify.error("Error adding item to cart");
      }
    },
    complete: function () {
      addToCartBtn
        .removeClass("disabled")
        .html("إضافة إلى السلة <i class='fas fa-cart-plus'></i>");
    },
  });*/
  $.ajax({
    url: addUrl,
    method: "POST",
    data: requestData,
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
    },
    success: function (response, textStatus, xhr) {
      // التحقق مما إذا كان الرد يحتوي على محتوى صفحة تسجيل الدخول
      if (
        response.includes("login") ||
        response.includes(i18n.global.t("common.login"))
      ) {
        // إذا كانت الاستجابة تحتوي على محتوى صفحة تسجيل الدخول
        console.log("Redirected to login page.");
        var myModal = new bootstrap.Modal(
          document.getElementById("loginModal")
        );
        myModal.show();

        showCart(); // عرض نافذة تسجيل الدخول
      } else {
        // إذا كانت الاستجابة صحيحة، أي أن العنصر قد أضيف إلى السلة بنجاح
        console.log("Item added to cart successfully!");
        Toast.fire({
          icon: "success",
          title: i18n.global.t("cart.add_success"),
        });
        showCart();
        //$("#cartModal").modal("show");
      }
    },
    error: function (xhr, status, error) {
      console.error("Error adding item to cart:", error);
      console.log(xhr.responseText);

      // التحقق من حالة الريسبونس في حال حدوث خطأ
      if (xhr.status === 302 || xhr.status === 204) {
        $("#loginModal").modal("show"); // عرض نافذة تسجيل الدخول
      } else {
        const responseText = xhr.responseText
          ? xhr.responseText.toLowerCase()
          : "";
        if (
          responseText.includes("already in cart") ||
          responseText.includes("already exists")
        ) {
          Toast.fire({
            icon: "info",
            title: i18n.global.t("cart.already_in_cart"),
          });
        } else {
          Toast.fire({
            icon: "error",
            title: i18n.global.t("cart.add_error"),
          });
        }
      }
    },
    complete: function () {
      addToCartBtn.removeClass("disabled").html(originalContent);
    },
  });
}
export function showCart() {
  let ImagePath;
  $.ajax({
    url: `${apiUrl}/show/cart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
    method: "POST",
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
    },
    success: function (response, textStatus, xhr) {
      if (response.cart && response.cart.length != 0) {
        const cartItems = response.cart;
        let tableRowsBundle = "";
        let tableRowsCourse = "";
        let couponExists = false;
        let couponApplied = false;
        for (let i = 0; i < cartItems.length; i++) {
          const cartItem = cartItems[i];
          let couponDetails = "";
          if (cartItem.cart_coupon) {
            couponExists = true;
            const coupon = cartItem.cart_coupon;
            const discountValue =
              coupon.discount_type === "PERCENTAGE"
                ? `${coupon.total_discount}%`
                : `${coupon.total_discount} ${window.appCurrency}`;
            couponDetails = `${i18n.global.t("cart.coupon")}:  ${i18n.global.t(
              "cart.discount"
            )}: ${discountValue}`;
          } else {
            couponDetails = "";
          }

          if (cartItem.course_id == null) {
            // Bundle item
            ImagePath = `${baseUrl}/images/bundle/`;
            const bundlePrice = cartItem.price;
            const bundleOfferPrice = cartItem.offer_price;
            let bundlePriceDisplay = "";
            if (
              bundleOfferPrice &&
              parseFloat(bundleOfferPrice) < parseFloat(bundlePrice)
            ) {
              const savings =
                parseFloat(bundlePrice) - parseFloat(bundleOfferPrice);
              bundlePriceDisplay = `
                <div class="price-comparison d-flex flex-column">
                  <div class="d-flex align-items-center gap-2">
                    <span class="original-price" style="color: #999; text-decoration: line-through; font-size: 0.9rem;">${bundlePrice} ${window.appCurrency}</span>
                    <span class="discount-price" style="color: #00c744; font-weight: 700; font-size: 1.1rem;">${bundleOfferPrice} ${window.appCurrency}</span>
                  </div>
                  <span class="savings-badge" style="background: linear-gradient(135deg, #e8fff1, #d4f7e4); color: #00a83b; padding: 3px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; margin-top: 4px; display: inline-block; width: fit-content;">
                    <i class="fas fa-tag me-1"></i>تخفيض
                  </span>
                </div>`;
            } else {
              bundlePriceDisplay = `<span class="amount-cart">${bundlePrice} ${window.appCurrency}</span>`;
            }
            const row = `<tr data-bundle-id='${cartItem.bundle_id}'>
            <td>${i + 1}</td>
            <td><img class='rounded' src='${
              cartItem.bundle.imagepath
            }' alt='Thumbnail' style='width: 70px; height: 70px;'></td>
            <td>${cartItem.bundle.title}</td>
            <td><b class="text-success">${couponDetails}</b></td>
            <td>${bundlePriceDisplay}</td>
            <td><button style="padding:5px 7px" class='remove-button btn btn-sm btn-dark' data-bundle-id='${
              cartItem.bundle_id
            }'><i class='fa fa-close'></i></button></td>
          </tr>`;
            tableRowsBundle += row;
          } else {
            // Course item
            ImagePath = `${baseUrl}/images/course/`;
            const coursePrice = cartItem.price;
            const courseOfferPrice = cartItem.offer_price;
            let coursePriceDisplay = "";
            if (
              courseOfferPrice &&
              parseFloat(courseOfferPrice) < parseFloat(coursePrice)
            ) {
              const savings =
                parseFloat(coursePrice) - parseFloat(courseOfferPrice);
              coursePriceDisplay = `
                <div class="price-comparison d-flex flex-column">
                  <div class="d-flex align-items-center gap-2">
                    <span class="original-price" style="color: #999; text-decoration: line-through; font-size: 0.9rem;">${coursePrice} ${window.appCurrency}</span>
                    <span class="discount-price" style="color: #00c744; font-weight: 700; font-size: 1.1rem;">${courseOfferPrice} ${window.appCurrency}</span>
                  </div>
                  <span class="savings-badge" style="background: linear-gradient(135deg, #e8fff1, #d4f7e4); color: #00a83b; padding: 3px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; margin-top: 4px; display: inline-block; width: fit-content;">
                    <i class="fas fa-tag me-1"></i>تخفيض
                  </span>
                </div>`;
            } else {
              coursePriceDisplay = `<span class="amount-cart">${coursePrice} ${window.appCurrency}</span>`;
            }
            const row = `<tr data-course-id='${cartItem.course_id}'>
            <td>${i + 1}</td>
            <td><img class='rounded' src='${
              cartItem.courses.imagepath
            }' alt='Thumbnail' style='width: 70px; height: 70px;'></td>
            <td>${cartItem.courses.title}</td>
            <td><b class="text-success">${couponDetails}</b></td>
            <td>${coursePriceDisplay}</td>
            <td><button class='remove-button btn btn-sm btn-dark' style="padding:5px 8px" data-course-id='${
              cartItem.course_id
            }'><i class='fa fa-close'></i></button></td>
          </tr>`;
            tableRowsCourse += row;
          }
        }

        $("#cartTableBodyBundle").html(tableRowsBundle);
        $("#cartTableBodyCourse").html(tableRowsCourse);
        $(".cart-tb").show();
        $(".remove-button").click(function () {
          const bundleId = $(this).data("bundle-id");
          const courseId = $(this).data("course-id");
          removeCartItem(bundleId, courseId);
        });

        if (couponExists) {
          const removeButton = $(
            `<button class="p-3 btn btn-danger btn-sm btn-block waves-effect waves-light" type="button">${i18n.global.t(
              "cart.remove_coupon"
            )} <i class="fa fa-trash"></i></button>`
          );
          removeButton.appendTo($("#removeCouponContainer"));
          removeButton.on("click", removeCoupon);
          $(".addCoupon").hide();
        } else {
          $(".addCoupon").show();

          $("#removeCouponContainer").empty();
        }
      } else {
        var empt = `
        <div class="col-12">
          <div class="empty-cart-container">
            <div class="empty-cart-illustration">
              <div class="cart-icon-wrapper">
                <i class="fas fa-shopping-cart"></i>
                <div class="cart-sparkle sparkle-1"><i class="fas fa-star"></i></div>
                <div class="cart-sparkle sparkle-2"><i class="fas fa-star"></i></div>
                <div class="cart-sparkle sparkle-3"><i class="fas fa-star"></i></div>
              </div>
            </div>
            <div class="empty-cart-content">
              <h2 class="empty-cart-title">${i18n.global.t("cart.empty")}</h2>
              <p class="empty-cart-subtitle">${i18n.global.t(
                "cart.empty_subtitle"
              )}</p>
              <a href="/courses" class="browse-courses-btn">
                <span class="btn-text">
                  <i class="fas fa-compass me-2"></i>
                  ${i18n.global.t("cart.browse_courses")}
                </span>
                <span class="btn-icon">
                  <i class="fas fa-arrow-left"></i>
                </span>
              </a>
            </div>
          </div>
        </div>`;
        $(".cartContent").html(empt);
      }
    },
    error: function (xhr, status, error) {
      console.error("Error retrieving cart:", error);
    },
  });
}

// Track pending undo operations
let pendingUndoTimeout = null;
let pendingUndoData = null;

export function removeCartItem(bundleId, courseId) {
  let removeUrl = `${apiUrl}/remove/cart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`;
  const requestData = {};
  let removeButton;
  let rowElement;

  if (bundleId) {
    requestData.bundle_id = bundleId;
    removeUrl = `${apiUrl}/remove/bundle?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`;
    removeButton = $(
      `#cartTableBodyBundle button[data-bundle-id='${bundleId}']`
    );
    rowElement = $(`#cartTableBodyBundle tr[data-bundle-id='${bundleId}']`);
  }
  if (courseId) {
    requestData.course_id = courseId;
    removeButton = $(
      `#cartTableBodyCourse button[data-course-id='${courseId}']`
    );
    rowElement = $(`#cartTableBodyCourse tr[data-course-id='${courseId}']`);
  }

  // If there's a pending undo, commit it immediately before starting new one
  if (pendingUndoTimeout) {
    clearTimeout(pendingUndoTimeout);
    if (pendingUndoData) {
      commitCartRemoval(pendingUndoData);
    }
    pendingUndoTimeout = null;
    pendingUndoData = null;
  }

  // Hide the row visually (with animation)
  rowElement.css({
    transition: "opacity 0.3s ease, transform 0.3s ease",
    opacity: "0.3",
    transform: "translateX(-10px)",
  });

  // Store data for potential undo
  pendingUndoData = {
    bundleId,
    courseId,
    removeUrl,
    requestData,
    rowElement,
    removeButton,
  };

  // Show undo toast
  const UndoToast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: true,
    showCloseButton: false,
    timer: 5000,
    timerProgressBar: true,
    backdrop: false,
    allowOutsideClick: true,
    confirmButtonText: `<i class="fas fa-undo me-1"></i>${i18n.global.t(
      "cart.undo"
    )}`,
    confirmButtonColor: "#6c757d",
    showClass: {
      popup: "cart-toast-fade-in",
    },
    hideClass: {
      popup: "cart-toast-fade-out",
    },
    customClass: {
      popup: "cart-toast-minimal cart-undo-toast",
      title: "cart-toast-title-minimal",
      confirmButton: "cart-undo-btn",
    },
  });

  UndoToast.fire({
    icon: "info",
    title: i18n.global.t("cart.item_removed"),
  }).then((result) => {
    if (result.isConfirmed) {
      // User clicked Undo - restore the item
      undoCartRemoval();
    } else if (result.dismiss === Swal.DismissReason.timer) {
      // Timer expired - commit the removal
      if (pendingUndoData) {
        commitCartRemoval(pendingUndoData);
        pendingUndoData = null;
      }
    }
  });

  // Set timeout to auto-commit removal
  pendingUndoTimeout = setTimeout(() => {
    // This is a fallback; the toast's timer should handle it
  }, 5500);
}

function undoCartRemoval() {
  if (!pendingUndoData) return;

  const { rowElement } = pendingUndoData;

  // Restore the row visually
  rowElement.css({
    transition: "opacity 0.3s ease, transform 0.3s ease",
    opacity: "1",
    transform: "translateX(0)",
  });

  // Clear pending data
  if (pendingUndoTimeout) {
    clearTimeout(pendingUndoTimeout);
    pendingUndoTimeout = null;
  }
  pendingUndoData = null;

  // Show success toast
  Toast.fire({
    icon: "success",
    title: i18n.global.t("cart.item_restored"),
  });
}

function commitCartRemoval(data) {
  const {
    bundleId,
    courseId,
    removeUrl,
    requestData,
    rowElement,
    removeButton,
  } = data;

  removeButton
    .addClass("disabled")
    .html(
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    );

  $.ajax({
    url: removeUrl,
    method: "POST",
    data: requestData,
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
    },
    success: function (response) {
      // Remove the row with animation
      rowElement.css({
        transition: "all 0.3s ease",
        opacity: "0",
        transform: "translateX(-20px)",
        maxHeight: "0",
        padding: "0",
        margin: "0",
      });
      setTimeout(() => {
        rowElement.remove();
        const cartInvoiceTable = $("#cartInvoiceTable");
        generateCartInvoice(cartInvoiceTable);
      }, 300);
    },
    complete: function () {
      removeButton
        .removeClass("disabled")
        .text(i18n.global.t("bundle.add_to_cart"));
    },
    error: function (xhr, status, error) {
      console.error("Error removing item from cart:", error);
      // Restore the row on error
      rowElement.css({
        transition: "opacity 0.3s ease, transform 0.3s ease",
        opacity: "1",
        transform: "translateX(0)",
      });
      Toast.fire({
        icon: "error",
        title: i18n.global.t("cart.remove_error"),
      });
    },
  });
}

export function generateCartInvoice(cartInvoiceTable) {
  $("#offerPercentCell").html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
  );
  $("#couponDiscountCell").html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
  );
  $("#totalPriceCell").html(
    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
  );
  $.ajax({
    url: `${apiUrl}/show/cart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
    method: "POST",
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
      $("#loader").addClass("spinner-border text-primary");
    },
    success: function (response) {
      if (response.cart) {
        console.log("Cart data retrieved successfully:", response);

        // Calculate total price and coupon discount
        let totalPrice = 0;
        let couponDiscount = 0;

        response.cart.forEach((cartItem) => {
          totalPrice += parseFloat(cartItem.price);
          if (cartItem.cart_coupon) {
            const coupon = cartItem.cart_coupon;
            if (coupon.discount_type === "PERCENTAGE") {
              couponDiscount +=
                (parseFloat(cartItem.price) * coupon.total_discount) / 100;
            } else {
              couponDiscount += coupon.total_discount;
            }
          }
        });

        const finalPrice = totalPrice - couponDiscount;

        $("#offerPercentCell").html(`${response.offer_percent}%`);
        $("#couponDiscountCell").html(
          `${couponDiscount.toFixed(2)} ${window.appCurrency}`
        );
        $("#totalPriceCell").html(
          `${response.cart_total - couponDiscount.toFixed(2)} ${
            window.appCurrency
          }`
        );
        $("#loader").removeClass("spinner-border text-primary");
      }
    },
    error: function (xhr, status, error) {
      console.error("Error retrieving cart:", error);
      $("#loader").removeClass("spinner-border text-primary");
    },
  });
}

// src/utils/cart.js
// src/utils/cart.js
export function applyCoupon(couponCode, button) {
  button
    .prop("disabled", true)
    .html(
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    );

  $.ajax({
    url: `${apiUrl}/apply/coupon/v2?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
    method: "POST",
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
    },
    data: { coupon: couponCode },
    success: function (response) {
      if (response && response.errors && response.errors.coupon) {
        Toast.fire({
          icon: "error",
          title: response.errors.coupon[0],
        });
      } else {
        Toast.fire({
          icon: "success",
          title: i18n.global.t("cart.apply_success"),
        });
        $("#applyCouponModal").modal("hide");
        location.reload();
      }
      // إرجاع الزر إلى حالته الطبيعية
      button
        .prop("disabled", false)
        .html(
          `${i18n.global.t("cart.apply")} <i class="mdi mdi-gift-outline"></i>`
        );
    },
    error: function (xhr, status, error) {
      Toast.fire({
        icon: "error",
        title: `${i18n.global.t("cart.apply_failed")}: ${error}`,
      });
      // إرجاع الزر إلى حالته الطبيعية
      button
        .prop("disabled", false)
        .html(
          `${i18n.global.t("cart.apply")} <i class="mdi mdi-gift-outline"></i>`
        );
    },
  });
}

export function removeCoupon() {
  Swal.fire({
    title: i18n.global.t("common.are_you_sure"),
    text: i18n.global.t("common.cannot_undo"),
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: i18n.global.t("cart.confirm_remove_coupon"),
    cancelButtonText: i18n.global.t("common.cancel"),
  }).then((result) => {
    if (result.isConfirmed) {
      $.ajax({
        url: `${apiUrl}/remove/coupon/v2?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
        method: "POST",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
        },
        success: function (response) {
          Swal.fire(
            i18n.global.t("common.removed"),
            i18n.global.t("cart.remove_success"),
            "success"
          ).then(() => {
            location.reload();
          });
        },
        error: function (xhr, status, error) {
          Swal.fire(
            i18n.global.t("common.error"),
            `${i18n.global.t("cart.remove_failed")}: ${error}`,
            "error"
          );
        },
      });
    }
  });
}

export function confirmPurchase(button) {
  // Show loading state while validating
  button
    .prop("disabled", true)
    .html(
      `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${i18n.global.t(
        "common.loading"
      )}`
    );

  // First, fetch cart total and wallet balance to validate
  Promise.all([
    // Fetch cart data
    $.ajax({
      url: `${apiUrl}/show/cart?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
      method: "POST",
      beforeSend: function (xhr) {
        xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
      },
    }),
    // Fetch wallet balance
    $.ajax({
      url: `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
      method: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
      },
    }),
  ])
    .then(function ([cartResponse, walletResponse]) {
      // Reset button state
      button
        .prop("disabled", false)
        .html(
          `${i18n.global.t(
            "checkout.confirm_button"
          )} <i class="fas fa-check"></i>`
        );

      // Calculate cart total with coupon discount
      let cartTotal = 0;
      let couponDiscount = 0;

      if (cartResponse.cart && cartResponse.cart.length > 0) {
        cartResponse.cart.forEach((cartItem) => {
          cartTotal += parseFloat(cartItem.price) || 0;
          if (cartItem.cart_coupon) {
            const coupon = cartItem.cart_coupon;
            if (coupon.discount_type === "PERCENTAGE") {
              couponDiscount +=
                (parseFloat(cartItem.price) * coupon.total_discount) / 100;
            } else {
              couponDiscount += coupon.total_discount || 0;
            }
          }
        });
      }

      // Use cart_total from response if available, otherwise use calculated total
      const finalTotal =
        (cartResponse.cart_total || cartTotal) - couponDiscount;

      // Parse wallet balance
      let walletBalance = 0;
      if (walletResponse) {
        const raw =
          walletResponse.wallet_balance ??
          walletResponse.walletBalance ??
          walletResponse.balance ??
          walletResponse.amount ??
          walletResponse.value ??
          (walletResponse.data &&
            (walletResponse.data.wallet_balance ??
              walletResponse.data.balance));
        if (typeof raw === "string") {
          const cleaned = raw.replace(/[^0-9.,-]/g, "").replace(/,/g, ".");
          walletBalance = parseFloat(cleaned) || 0;
        } else {
          walletBalance = parseFloat(raw) || 0;
        }
      }

      // Check if wallet balance is sufficient
      if (walletBalance < finalTotal) {
        const shortfall = (finalTotal - walletBalance).toFixed(2);
        Swal.fire({
          title:
            i18n.global.t("checkout.insufficient_balance_title") ||
            "رصيد غير كافي",
          html: `
            <div style="text-align: center;">
              <p>${
                i18n.global.t("checkout.insufficient_balance_text") ||
                "رصيد محفظتك غير كافٍ لإتمام عملية الشراء"
              }</p>
              <div style="margin: 15px 0; padding: 15px; background: #f8f9fa; border-radius: 10px;">
                <p style="margin: 5px 0;"><strong>${
                  i18n.global.t("checkout.cart_total") || "إجمالي السلة"
                }:</strong> ${finalTotal.toFixed(2)} ${window.appCurrency}</p>
                <p style="margin: 5px 0;"><strong>${
                  i18n.global.t("checkout.wallet_balance") || "رصيد المحفظة"
                }:</strong> ${walletBalance.toFixed(2)} ${
            window.appCurrency
          }</p>
                <p style="margin: 5px 0; color: #dc3545;"><strong>${
                  i18n.global.t("checkout.amount_needed") || "المبلغ المطلوب"
                }:</strong> ${shortfall} ${window.appCurrency}</p>
              </div>
            </div>
          `,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3ddc97",
          cancelButtonColor: "#6c757d",
          confirmButtonText:
            i18n.global.t("checkout.charge_wallet") || "شحن المحفظة",
          cancelButtonText: i18n.global.t("common.cancel") || "إلغاء",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/Wallet";
          }
        });
        return;
      }

      // Balance is sufficient, proceed with confirmation
      Swal.fire({
        title: i18n.global.t("checkout.confirm_title"),
        text: "  ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3ddc97",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: i18n.global.t("common.no"),
        confirmButtonText: i18n.global.t("common.yes"),
      }).then(function (result) {
        if (result.isConfirmed) {
          button
            .prop("disabled", true)
            .html(
              `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${i18n.global.t(
                "common.loading"
              )}`
            );
          $.ajax({
            url: `${apiUrl}/checkout?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
            method: "POST",
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
            },
            success: function (response) {
              Swal.fire({
                title: i18n.global.t("checkout.success_title"),
                text: i18n.global.t("checkout.success_text"),
                icon: "success",
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then(() => {
                window.location.href = "/Dashboard";
              });
              console.log(response);
            },
            error: function (xhr, status, error) {
              Swal.fire(
                i18n.global.t("checkout.error_title"),
                i18n.global.t("checkout.error_text"),
                "error"
              );
              button
                .prop("disabled", false)
                .html(
                  `${i18n.global.t(
                    "checkout.confirm_button"
                  )} <i class="fas fa-check"></i>`
                );
            },
          });
        }
      });
    })
    .catch(function (error) {
      console.error("Error validating purchase:", error);
      button
        .prop("disabled", false)
        .html(
          `${i18n.global.t(
            "checkout.confirm_button"
          )} <i class="fas fa-check"></i>`
        );
      Swal.fire(
        i18n.global.t("common.error") || "خطأ",
        i18n.global.t("checkout.validation_error") ||
          "حدث خطأ أثناء التحقق من البيانات",
        "error"
      );
    });
}
